import React, { useEffect } from "react";
import { Container, Nav } from "react-bootstrap";
import {useNavigate } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { isSubscribedAccountant } from "../../utils";

const Indexbusinesstools = () => {
    const navigate = useNavigate()
    useEffect(() => {
      if (!isSubscribedAccountant()) {
        navigate("/users/billings");
        window.location.reload();
      }
    }, []);

    return (
        <Container fluid>
            <div className="mx-3">
                {/* <Slider {...settings}> */}
                <Nav variant="pills" className="border-tab nav-primary">
                    {/* <Nav.Item>
                        <Nav.Link as={NavLink} to="/businesstool/people" exact>
                            <FaUserFriends className="me-1" /> People
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link as={NavLink} to="/businesstool/process" exact>
                            <FaProjectDiagram  className="me-1" /> Process
                        </Nav.Link>
                    </Nav.Item> */}


                    {/* <Nav.Item>
                        <Nav.Link as={NavLink} to="/businesstool/technology" exact>
                            <FaBoxesStacked className="me-1" /> Technology
                        </Nav.Link>
                    </Nav.Item> */}
                </Nav>
            </div>
        </Container>
    );
};

export default Indexbusinesstools;
